import "./theme.css";
import "./base.css";
import "./code.css";
import "./codehilite.css";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import { LuPentagon } from "react-icons/lu";
import { FaRegQuestionCircle } from "react-icons/fa";
import { FaRegNewspaper } from "react-icons/fa6";

const BaseNav = (props) => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(null);
  const updatepath = () => {
    let path = location.pathname;
    setActiveLink(path);
  };
  useEffect(() => {
    updatepath();
  }, [location.pathname]);

  const TopLinks = [
    { name: "Home", path: "/", icon: <LuPentagon size={"1.4rem"} /> },
    { name: "Blog", path: "/blog", icon: <FaRegNewspaper size={"1.4rem"} /> },
  ];
  const BottomLinks = [
    {
      name: "About",
      path: "/about",
      icon: <FaRegQuestionCircle size={"1.4rem"} />,
    },
  ];

  return (
    <nav className="base-nav">
      <div className="base-nav-top">
        {TopLinks.map((link, index) => (
          <Link
            key={index}
            to={link.path}
            pageloaded={(activeLink === link.path).toString()}
          >
            {link.icon}
          </Link>
        ))}
      </div>
      <div className="base-nav-bottom">
        {BottomLinks.map((link, index) => (
          <Link
            key={index}
            to={link.path}
            pageloaded={(activeLink === link.path).toString()}
          >
            {link.icon}
          </Link>
        ))}
      </div>
    </nav>
  );
};

const BasePage = (props) => {
  return (
    <div className="base-container">
      <BaseNav />
      <div className="base-content">{props.children}</div>
    </div>
  );
};

export { BasePage };
